import { JsonApiProfileInternships } from '../../@types/jsonapi';

export function allProfileInternshipsCollectionJsonApi(
  store: ReduxStore,
): JsonApiProfileInternships[] {
  return store?.api?.profileInternships || [];
}
